import API_URL from "@/constant/api.config";
import { setAuthHeaders } from "@/utils/common";
import axiosInstance from '@/axiosHttp';

export const createRequest = async (data) => {

    const headers = setAuthHeaders();
    const response = await axiosInstance.post(API_URL + "/member/upgrade-plan-request", data, {
        headers
    });
    return response.data ? response.data.data : null;
}